import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import ClearIcon from "@mui/icons-material/Clear";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";

const TaskTypeChangeWarning = ({
  open,
  onClose,
  onConfirm,
  fieldsToNullify,
  newTaskType,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
          pt={2}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WarningIcon sx={{ fontSize: 40, color: "#FF6F00" }} />
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Urbanist, Verdana, Arial, sans-serif",
              fontSize: "20px",
              fontWeight: 700,
              letterSpacing: "0.05em",
              color: "#FF6F00",
            }}
          >
            Change Task Type
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography
            sx={{
              fontFamily: "Urbanist, Verdana, Arial, sans-serif",
              fontSize: "14px",
              color: "#666",
              mb: 2,
            }}
          >
            Changing Task Type to <strong>{newTaskType}</strong> will clear the
            following fields <strong>when you save</strong>:
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "#FFF3E0",
            borderRadius: "8px",
            padding: 2,
            border: "1px solid #FFE0B2",
          }}
        >
          <List dense disablePadding>
            {fieldsToNullify.map((field, index) => (
              <ListItem key={index} disableGutters>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <ClearIcon sx={{ fontSize: 18, color: "#FF6F00" }} />
                </ListItemIcon>
                <ListItemText
                  primary={field}
                  primaryTypographyProps={{
                    sx: {
                      fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                      fontSize: "13px",
                      color: "#424242",
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>

        <Typography
          sx={{
            fontFamily: "Urbanist, Verdana, Arial, sans-serif",
            fontSize: "13px",
            color: "#666",
            mt: 2,
            textAlign: "center",
            fontStyle: "italic",
          }}
        >
          This action cannot be undone. Are you sure you want to continue?
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 3, px: 3 }}>
        <CustomButton
          variant="outlined"
          onClick={onClose}
          sx={{
            minWidth: 85,
          }}
        >
          Cancel
        </CustomButton>
        <CustomButton
          variant="contained"
          onClick={onConfirm}
          sx={{
            minWidth: 85,
          }}
        >
          Continue
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default TaskTypeChangeWarning;
